<div class="contents-area">
  <div class="block-row">
    <div>
      <!-- 検索条件(必須)領域 -->
      <h2>検索条件(必須)</h2>
      <div class="element-column">
        <div class="block-row">
          <div class="column-list">
            <label class="list-input-title">受注コード</label>
            <div class="list-input-content">
              <app-order-code-text-input id="txt_OrderCode" #txt_OrderCode [subid]="'txt_OrderCode'" [required]="true"
                [catalogIDField]="lbl_DelivCatalogId" [forcedEnabledMode]="'true'" [tabindex]="0" [editable]="true"
                [autofocus]="true" [(ngModel)]="kymw2100Model.orderCode"
                (ngModelChange)="eventOrderCode_CHANGEHandler(null)">
              </app-order-code-text-input>
            </div>
            <label class="list-input-title">媒体</label>
            <div class="list-input-content">
              <select id="cmb_MediumType" #cmb_MediumType [tabindex]="0" class="text-label-required"
                forcedEnabledMode="true" (change)="eventMediumType_CHANGEHandler($event)"
                [(ngModel)]="kymw2100Model.mediumType" style="width:205px">
                <ng-template ngFor let-item [ngForOf]="kymw2100Model.mediumTypeList">
                  <option value="{{item.MediumType}}">{{item.MediumTypeName}}</option>
                </ng-template>
              </select>
            </div>
            <label class="list-input-title">会員生協</label>
            <div class="list-input-content">
              <app-coop-code-combo-box [required]="true" [(ngModel)]="kymw2100Model.coopCode" id="cmb_CoopCode"
                #cmb_CoopCode [subid]="'cmb_CoopCode'" [tabindex]="0" [allCoop]="true" [forcedEnabledMode]="'none'"
                (change)="eventCoopCode_CHANGEHandler(null)">
              </app-coop-code-combo-box>
            </div>
          </div>
          <div class="column-list">
            <label class="list-input-title">配達企画回(翌週)</label>
            <div class="list-input-content">
              <input type="text" id="lbl_DelivCatalogId" class="disabled-border deliv-catalog" #lbl_DelivCatalogId
                style="position: relative;" readonly />
            </div>
            <label class="list-input-title">フェーズ</label>
            <div class="list-input-content">
              <input type="text" style="text-wrap:nowrap; width:27rem;" value="{{kymw2100Model.codeName}}" readonly>
            </div>
          </div>
        </div>
        <button id="btn_Search" class="btn-secondary" #btn_Search forcedEnabledMode="none" [tabindex]="0"
          (click)="eventSearch_CLICKHandler(null)">検索</button>
      </div>
    </div>

    <div>
      <!-- 検索条件(任意)領域 -->
      <h2>検索条件(任意)</h2>
      <div class="element-column">
        <div class="column-list">
          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content">
            <input type="text" id="txt_PCode" class="list-input-content pcode" #txt_PCode [maxlength]="8"
              forcedEnabledMode="none" plessInputTextSub [restrict]="'[P0-9]'" [tabindex]="0"
              [(ngModel)]="kymw2100Model.pCode">
          </div>
          <label class="list-input-title">注文コード</label>
          <div class="list-input-content">
            <input type="text" id="txt_OrderNumFrom" class="deliv-catalog" #txt_OrderNumFrom [maxlength]="6"
              forcedEnabledMode="none" plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0"
              [(ngModel)]="kymw2100Model.orderNumFrom">
            <label>～</label>
            <input type="text" id="txt_OrderNumTo" class="deliv-catalog" #txt_OrderNumTo [maxlength]="6"
              forcedEnabledMode="none" plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0"
              [(ngModel)]="kymw2100Model.orderNumTo">
          </div>
          <label class="list-input-title">ページ</label>
          <div class="list-input-content">
            <input type="text" id="txt_PageNumFrom" class="page" #txt_PageNumFrom [maxlength]="3"
              forcedEnabledMode="none" plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0"
              [(ngModel)]="kymw2100Model.pageNumFrom">
            <label>～</label>
            <input type="text" id="txt_PageNumTo" class="page" #txt_PageNumTo [maxlength]="3" forcedEnabledMode="none"
              plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0" [(ngModel)]="kymw2100Model.pageNumTo">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <h2>一括付番設定</h2>
    <div class="element-column">
      <div class="block-row">
        <div class="column-list">
          <label class="list-input-title">使用注文コード</label>
          <div class="list-input-content">
            <input type="text" id="txt_AvailableOrderNumFrom" class="deliv-catalog" #txt_OrderNumStart
              [maxlength]="6" forcedEnabledMode="none" plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0"
              [(ngModel)]="kymw2100Model.availableOrderNumFrom" style="width:5rem">
            <label>～</label>
            <input type="text" id="txt_AvailableOrderNumTo" class="deliv-catalog" #txt_OrderNumEnd [maxlength]="6"
              forcedEnabledMode="none" plessInputTextSub [restrict]="'[0-9]'" [tabindex]="0"
              [(ngModel)]="kymw2100Model.availableOrderNumTo" style="width:5rem">
          </div>
        </div>
        <div class="column-list">
          <label class="list-input-title">付番対象</label>
          <div class="list-input-content">
            <app-checkbox-label #chb_UnnumberedOnlyFlg id="chb_UnnumberedOnlyFlg" [subid]="'chb_UnnumberedOnlyFlg'"
              [tabindex]="0" (change)="eventCheckbox_CHANGEHandler()"
              [(ngModel)]="kymw2100Model.unnumberedOnlyFlg" label="注文コードが未付番の商品のみ">
            </app-checkbox-label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 注文コード一覧領域 -->
  <div>
    <h2>注文コード一覧</h2>
    <!-- データグリッド定義(注文コード一覧) -->
    <wj-flex-grid #dtg_OrderNumList [itemsSource]="kymw2100Model.orderNumList" class="space-bottom" [tabindex]="0"
      id="dtg_OrderNumList" [headersVisibility]="'Column'" [isReadOnly]="kymw2100Model.readOnlyOrderNumList"
      [allowSorting]="true" [selectionMode]="'Row'" [deferResizing]="false" [allowDragging]="'None'"
      (pasting)="onPasting($event)">
      <wj-flex-grid-column [minWidth]="5" [header]="'ステータス'" [width]="100" [binding]="'Status'"
        [isReadOnly]="true"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'注文コード'" [width]="140" [binding]="'OrderNum'" id="dgc_OrderNum"
        #dgc_OrderNum [isReadOnly]="kymw2100Model.readOnlyOrderNum">
        <ng-template wjFlexGridCellTemplate [cellType]="'CellEdit'" let-cell="cell">
          <input type="text" [style.width.%]="100" [style.margin-left.px]="-3" [style.margin-top.px]="-3"
            plessInputTextSub [restrict]="'[0-9]'" [maxlength]="6" [(ngModel)]="cell.item.OrderNum" autocomplete="off"
            [tabindex]="-1" (keydown)="eventGridKeyDownHandler($event,dtg_OrderNumList,1)" />
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'3桁'" [width]="60" [binding]="'Digits3'" [isReadOnly]="true"
        [align]="'center'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'6桁'" [width]="60" [binding]="'Digits6'" [isReadOnly]="true"
        [align]="'center'">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="140" [binding]="'PCode'" [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="500" [binding]="'GuideGoodsName'"
        [isReadOnly]="true">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.GuideGoodsName || cell.item.CouponName}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="426"
        [binding]="'GuideStandardName'" [isReadOnly]="true">
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'ページ'" [width]="90" [binding]="'PageNum'" [isReadOnly]="true"
        sortCompareFunction="sortPageNum" [sortMemberPath]="'SortPageNum'">
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.PageNum}}</div>
        </ng-template>
      </wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [header]="'Seq.NO'" [width]="90" [binding]="'OrderNumSeqNo'"
        [isReadOnly]="true" sortCompareFunction="sortOrderNumSeqNo" [sortMemberPath]="'SortOrderNumSeqNo'"> <ng-template
          wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
          <div>{{cell.item.OrderNumSeqNo}}</div>
        </ng-template>
      </wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>

<footer class="footer-buttons">
  <button id="btn_Reset" class="btn-tartiary" #btn_Reset [tabindex]="0"
    (click)="eventReset_CLICKHandler(null)">変更を取り消す</button>
  <button [tabindex]="0" id="btn_Numbering" class="btn-secondary" #btn_Numbering
    (click)="eventNumbering_CLICKHandler(null)">一括付番</button>
  <button id="btn_Set" class="btn-primary" #btn_Set [tabindex]="0" (click)="eventSet_CLICKHandler(null)">設定</button>
</footer>
